import { render, staticRenderFns } from "./project-expert-list.vue?vue&type=template&id=1e63e223&scoped=true&"
import script from "./project-expert-list.vue?vue&type=script&lang=js&"
export * from "./project-expert-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63e223",
  null
  
)

export default component.exports